import * as React from "react";
import { useState, FunctionComponent, useEffect } from "react";
import { styled, Block, IBlockProps } from "../../../seenspire-library";
import playIcon from "../../../assets/playIcon.svg";
import pauseIcon from "../../../assets/pauseIcon.svg";

export interface HTMLMediaControls {
  play: () => Promise<void> | void;
  pause: () => void;
  mute: () => void;
  unmute: () => void;
  volume: (volume: number) => void;
  seek: (time: number) => void;
}
const PlayPauseIconStyled = styled(Block)`
  border-radius: 50%;
  background-color: #00000060;
  height: 70px;
  width: 70px;
  display: grid;
  align-items: center;
  justify-items: center;
`;

const PlayPauseIcon: FunctionComponent<
  IBlockProps & {
    showIcons: boolean;
    controls: HTMLMediaControls;
    isPaused: boolean;
  }
> = ({ showIcons, controls, isPaused, ...props }) => {
  const [currentIcon, setCurrentIcon] = useState(playIcon);
  const [show, setShow] = useState(false);
  const toggleStatus = () => {
    if (isPaused) {
      controls.play();
    } else {
      controls.pause();
    }
  };

  useEffect(() => {
    setShow(showIcons);
  }, [showIcons]);

  useEffect(() => {
    if (isPaused) {
      setCurrentIcon(playIcon);
    } else {
      setCurrentIcon(pauseIcon);
    }
  }, [isPaused]);

  return (
    <PlayPauseIconStyled
      opacity={isPaused ? 1 : show ? 1 : 0}
      transition
      cursor="pointer"
      onClick={toggleStatus}
      {...props}
    >
      <img
        style={{
          width: 28,
          height: 28,
          paddingLeft: isPaused ? 7 : 0,
        }}
        src={currentIcon}
      />
    </PlayPauseIconStyled>
  );
};

export default PlayPauseIcon;
